module.exports = __webpack_public_path__ + "img/NS-004.fc037a73.png";